import React from 'react';
// Import Component Styles
import auth from 'shared-components/src/utils/auth';
import { get } from 'shared-components/src/utils/http';
import { StyledButton } from './styles';
// Import Utils

export default () => {
  // Handle logging user out of application
  const handleLogout = async () => {
    try {
      // Call backend to revoke refresh tokens
      await get('/api/v1/cardholder_portal/logout');
    } catch (error) {
      // Ignore errors - still logout on frontend
      console.warn('Logout API call failed:', error);
    } finally {
      // Clear local storage and redirect
      // eslint-disable-next-line no-return-assign
      auth.logout().then(() => (window.location.pathname = '/'));
    }
  };

  return (
    <StyledButton
      variant="text"
      onClick={handleLogout}
      page="nav"
      buttonFor="logout"
      buttonText="Logout"
    />
  );
};
